import { render, staticRenderFns } from "./fzjc-folder.vue?vue&type=template&id=5e72ca3d&scoped=true&"
import script from "./fzjc-folder.vue?vue&type=script&lang=ts&"
export * from "./fzjc-folder.vue?vue&type=script&lang=ts&"
import style0 from "./fzjc-folder.vue?vue&type=style&index=0&id=5e72ca3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72ca3d",
  null
  
)

export default component.exports